import { render, staticRenderFns } from "./PostDemandModal.vue?vue&type=template&id=33c73a5a&scoped=true"
import script from "./PostDemandModal.vue?vue&type=script&lang=js"
export * from "./PostDemandModal.vue?vue&type=script&lang=js"
import style0 from "./PostDemandModal.vue?vue&type=style&index=0&id=33c73a5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c73a5a",
  null
  
)

export default component.exports